import { useRef } from "react";

const EMPTY_STRING_ARRAY: string[] = [];

export function useStableStringArray(values: string[] | null | undefined): string[] {
  const nextValues = values ?? EMPTY_STRING_ARRAY;
  const nextValuesKey = JSON.stringify(nextValues);
  const refValues = useRef(nextValues);
  const refValuesKey = useRef(nextValuesKey);

  if (refValuesKey.current !== nextValuesKey) {
    refValues.current = nextValues;
    refValuesKey.current = nextValuesKey;
  }

  return refValues.current;
}
